import { render } from "./InventoryNav_Main.vue?vue&type=template&id=179be6ff&scoped=true"
import script from "./InventoryNav_Main.vue?vue&type=script&lang=js"
export * from "./InventoryNav_Main.vue?vue&type=script&lang=js"

import "./InventoryNav_Main.vue?vue&type=style&index=0&id=179be6ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179be6ff"]])

export default __exports__